<template>
    <form class="product-page-cart" @submit.prevent="onSubmit">

        <div class="product-page-cart__variants" v-if="weightItems.length">
            <div class="product-page-variants" v-if="product.CAN_BUY">
                <label class="product-page-variants__item" v-for="(item, index) in weightItems" :key="index">
                    <input type="radio" autocomplete="off" class="product-page-variants__item-input" name="weight"  :value="item.VALUE" v-model="selectedWeight">
                    <div class="product-page-variants__item-inner">
                        <div class="product-page-variants__item-weight" v-html="item.PRINT_VALUE"></div>
                        <div class="product-page-variants__item-price" v-html="item.PRICE.PRINT_DISCOUNT_VALUE"></div>
                    </div>
                </label>
            </div>

            <div class="product-page-variants" v-else>
                <label class="product-page-variants__item" v-for="(item, index) in weightItems" :key="index">
                    <input type="radio" autocomplete="off" class="product-page-variants__item-input" name="weight"  :value="item.VALUE" v-model="selectedWeight">
                    <div class="product-page-variants__item-inner">
                        <div class="product-page-variants__item-weight" v-html="item.PRICE.PRINT_DISCOUNT_VALUE"></div>
                    </div>
                </label>
            </div>
        </div>

         <div class="product-page-cart__variants" v-if="quantityItems.length">
            <div class="product-page-variants" v-if="product.CAN_BUY">
                <label class="product-page-variants__item" v-for="(item, index) in quantityItems" :key="index">
                    <input type="radio" autocomplete="off" class="product-page-variants__item-input" name="weight"  :value="item.VALUE" v-model="selectedQuantity">
                    <div class="product-page-variants__item-inner">
                        <div class="product-page-variants__item-weight" v-html="`${item.PRINT_VALUE} шт`"></div>
                        <div class="product-page-variants__item-price" v-html="item.PRICE.PRINT_DISCOUNT_VALUE"></div>
                    </div>
                </label>
            </div>

             <div class="product-page-variants" v-else>
                 <label class="product-page-variants__item" v-for="(item, index) in quantityItems" :key="index">
                     <input type="radio" autocomplete="off" class="product-page-variants__item-input" name="weight"  :value="item.VALUE" v-model="selectedQuantity">
                     <div class="product-page-variants__item-inner">
                         <div class="product-page-variants__item-weight" v-html="`${item.PRINT_VALUE} шт`"></div>
                     </div>
                 </label>
             </div>
        </div>

        <div class="product-page-cart__hint" v-if="roast.length > 1 && showDetailHint">
            <a class="product-page-cart__hint-close" @click="hideHint('BX_ONBOARDING_DETAIL_CLOSE')">
                <svg width="20" height="20"><use xlink:href="/sprite.svg#icon-close-nofill"></use></svg>
            </a>
            <div class="product-page-cart__hint-text">{{ hintMessage }}</div>
        </div>

        <template v-if="brewingTypes !== undefined && roast.length > 1">
            <div class="product-page-cart__title">Выберите способ приготовления:</div>
            <div class="product-page-cart__brewing-types open">
                <button type="button" class="product-page-cart__brewing-item" v-for="(item, index) in brewingTypes" :key="index" @click="selectBrewingType(item.DEFAULT, $event.currentTarget)" :data-roast="computedRoast(item.DEFAULT)" :data-id="`${item.ID}`">
                    <img class="" :src="`${item.ICON}`" alt="">
                    <span>{{ item.NAME }}</span>
                </button>
            </div>
            <a href="#" class="product-page-cart__more" @click.prevent="showMore($event)">Свернуть</a>
        </template>

        <div class="product-page-cart__selects" v-if="roast.length || grinding.length">
            <div class="custom-radio-wrapper" v-if="roast.length">
                <div class="product-page-cart__title" v-if="roast.length > 1">Выберите профиль обжарки:</div>
                <div class="product-page-cart__title" v-else>Профиль обжарки:</div>
                <roast-select :roastItems="roast" v-model="selectedRoastValue" @input="onChangeRoast"/>
            </div>

            <label class="custom-select-wrapper" v-if="grinding.length">
                <div class="product-page-cart__title">Помолоть?</div>
                <grinding-select :grinding-items="grinding" v-model="selectedGrindingId" />
            </label>

        </div>

        <div class="product-page-cart__bottom" v-if="product.CAN_BUY">

            <div class="product-page-cart__prices">
                <div class="product-page-cart__prices-item product-page-cart__prices-item--old" v-if="prices.old" v-html="prices.old"></div>
                <div class="product-page-cart__prices-item" v-html="prices.current"></div>
            </div>

            <template v-if="canBuy">
                <div class="product-page-cart__counter">
                    <quantity-input v-model="quantity" />
                </div>

                <div class="product-page-cart__btn">
                    <span class="product-page-cart__btn-info" v-if="productCount">Купили {{ getProductCount }}</span>
                    <button class="btn btn-main btn-block" :disabled="productInCart">
                        <template v-if="productInCart">В корзине</template>
                        <template v-else>В корзину</template>
                    </button>
                </div>
            </template>
        </div>

        <div class="product-page-cart__error" v-if="error">
            {{ error }}
        </div>

        <transition name="fade">
            <div class="product-page-cart__spinner" v-if="isLoading">
                <div class="spinner-border text-main" role="status" />
            </div>
        </transition>

    </form>
</template>

<script>
import Cookies from 'js-cookie';
import { EVENT_ADD_TO_CART, EVENT_DETAIL_OFFER_PAGE } from '../../services/event-bus/event-types';

import GrindingSelect from '../common/fields/grinding-select';
import RoastSelect from '../common/fields/roast-select';
import QuantityInput from '../common/quantity-input';
import { globalErrorHandler } from '../../services/error-handling';

const { eventBus } = window.specialtyApp;

export default {
    name: 'coffee-page-controls',

    inject: ['$basketService'],

    components: {
        GrindingSelect,
        RoastSelect,
        QuantityInput,
    },
    data() {
        return {
            quantity: null,
            selectedWeight: null,
            selectedGrindingId: null,
            selectedRoastValue: null,
            isLoading: false,

            isWeightValueInit: false,
            isRoastValueInit: false,

            error: null,

            oldQuantity: 1,
            productChangeProcess: false,
            clickOnBrew: false,

            selectedQuantity: null,
            initActiveOfferIdFromLink: new URL(window.location.href).searchParams.get('offer'),
            hintMessage: 'Выберите способ приготовления, и мы порекомендуем вам подходящий помол и профиль обжарки.',
        };
    },
    props: {
        product: {
            type: Object,
            required: true,
        },

        brewingTypes: {
            type: Array,
        },

        productCount: {
            type: Number,
        },
    },
    methods: {
        onSubmit() {
            this.addToBasket();
        },

        async addToBasket() {
            this.isLoading = true;
            this.error = null;

            let props = {};

            if (this.selectedGrinding?.VALUE) {
                props = {
                    pomol: {
                        name: 'Помол',
                        value: this.selectedGrinding.VALUE,
                    },
                };
            }

            try {
                const { data: { data, message } } = await this.$basketService.addToBasket(
                    this.currentOffer?.ID || this.product.ID,
                    this.quantity,
                    props,
                );

                if (message) {
                    this.error = message;
                    return;
                }

                eventBus.$emit(EVENT_ADD_TO_CART, {
                    basketData: data,
                    quantity: this.quantity,
                    type: this.product.IBLOCK_CODE,
                    actualItem: this.product,
                    offer: this.currentOffer,
                    grinding: this.selectedGrinding,
                });
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        async updateInBasket() {
            this.isLoading = true;
            try {
                await this.$basketService.updateInBasket(this.productInCart.ID, this.quantity);
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        updateQuantityHandler: BX.debounce(function handler() {
            this.updateInBasket();
        }, 500),

        quantityWatchHandler(newQuantity, oldQuantity) {
            if (newQuantity === '') {
                this.oldQuantity = oldQuantity;
                return;
            }

            if (
                newQuantity === oldQuantity
                || !this.productInCart
                || this.productChangeProcess
            ) {
                return;
            }

            this.updateQuantityHandler();
        },

        getInitOffer(selections) {
            let actualOffer = null;
            const items = selections.slice();
            const id = this.activeOfferId;

            actualOffer = id ? items.find((item) => +item.OFFERS[id] === +id) : null;

            return actualOffer;
        },

        declOfNum(number, words) {
            return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
        },

        getCountValues(val) {
            const pluralString = this.declOfNum(val, [' раз', ' раза', ' раз']);

            return val + pluralString;
        },

        showMore(evt) {
            const link = evt.target;
            const brewingTypes = document.querySelector('.product-page-cart__brewing-types');

            if (brewingTypes.classList.contains('open')) {
                link.innerText = 'Смотреть все';
            } else {
                link.innerText = 'Свернуть';
            }
            brewingTypes.classList.toggle('open');
        },

        selectBrewingType(val, item) {
            this.clickOnBrew = true;
            if (Object.keys(val).length < 2) {
                if (val.ESPRESSO === 'Y') {
                    this.hintMessage = 'Для выбранного способа приготовления лучше всего подходит обжарка Эспрессо. По умолчанию выбран кофе в зернах, вы можете изменить помол по желанию.';
                    this.selectedRoastValue = 'эспрессо';
                } else if (val.FILTER === 'Y') {
                    this.hintMessage = 'Для выбранного способа приготовления лучше всего подходит обжарка Фильтр. По умолчанию выбран кофе в зернах, вы можете изменить помол по желанию.';
                    this.selectedRoastValue = 'фильтр';
                }
            } else {
                this.hintMessage = 'Для крепкого вкуса выберите обжарку Эспрессо, для кислинки - Фильтр.\n'
                    + 'По умолчанию выбран кофе в зернах, вы можете изменить помол по желанию.';
            }

            $('.product-page-cart__brewing-item').removeClass('active');

            item.classList.toggle('active');
        },

        computedRoast(type) {
            if (Object.keys(type).length < 2) {
                if (type.ESPRESSO === 'Y') {
                    return 'эспрессо';
                }

                if (type.FILTER === 'Y') {
                    return 'фильтр';
                }
            }

            return 'both';
        },

        selectBrewingTypes(val) {
            if (!this.clickOnBrew) {
                $('.product-page-cart__brewing-item').removeClass('active');

                $('.product-page-cart__brewing-item').each(function () {
                    if ($(this).data('roast') === val) {
                        $(this).addClass('active');
                    }
                });
            }
        },

        hideHint(val) {
            if (!Cookies.get(val)) {
                Cookies.set(val, 'Y');
            }

            $('.product-page-cart__hint').hide(300);
        },

        onChangeRoast() {
            this.clickOnBrew = false;
        },
        getMinWeightOffer(){
            const offers = Object.values(this.product?.OFFERS);

            offers.sort((a, b)=>{

                const aw = Number.parseInt(a.PROPERTIES?.VES_UPAKOVKI?.VALUE);
                const bw = Number.parseInt(b.PROPERTIES?.VES_UPAKOVKI?.VALUE);
                if (aw > bw) return 1; // если первое значение больше второго
                if (aw === bw) return 0; // если равны
                if (aw < bw) return -1; // если первое значение меньше второго
            });
            return offers[0];
        },
        getMinPriceOffer() {
            const offers = Object.values(this.product?.OFFERS);

            offers.sort((a, b) => {
                const af = a.PROPERTIES?.STEPEN_OBZHARKI?.VALUE === 'фильтр' ? -1 : 1;
                const bf = b.PROPERTIES?.STEPEN_OBZHARKI?.VALUE === 'фильтр' ? -1 : 1;
                return a.CURRENT_PRICE?.DISCOUNT_VALUE - b.CURRENT_PRICE?.DISCOUNT_VALUE || af - bf;
            });

            const currentOffer = offers[0];
            return currentOffer.ID;
            // this.selectedWeight = currentOffer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
            // this.selectedRoast = currentOffer?.PROPERTIES.STEPEN_OBZHARKI.VALUE;
        },
    },
    computed: {
        getProductCount() {
            return this.getCountValues(this.productCount);
        },

        activeOfferId() {
            // return this.initActiveOfferIdFromLink || this.product.ACTIVE_OFFER_ID;
            // выбор активного оффера по мин цене
            return this.initActiveOfferIdFromLink || this.getMinPriceOffer();
        },

        canBuy() {
            if (this.product.OFFERS.length) {
                return this.currentOffer?.CAN_BUY;
            }

            return this.product.CAN_BUY;
        },

        grinding() {
            return Array.from(this.product.PROPERTIES?.POMOL?.LIST || []);
        },

        selectedGrinding() {
            return this.grinding.find((el) => el.ID === this.selectedGrindingId);
        },

        roast() {
            try {
                return Object.values(this.product.FILTERS.ROAST_DEGREE || {});
            } catch (error) {
                return [];
            }
        },

        selectedRoast() {
            return this.roast.find((el) => el.VALUE === this.selectedRoastValue);
        },

        weightItems() {
            return Object.values(this.product.FILTERS.WEIGHT || {})
                .filter((item) => Object.values(this.product.OFFERS)
                    .find((offer) => {
                        const normalWeightValue = offer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                        const roastValue = offer?.PROPERTIES?.STEPEN_OBZHARKI?.VALUE;

                        return normalWeightValue === `${item.VALUE}`
                                && roastValue === this.selectedRoastValue;
                    }));
        },

        quantityItems() {
            return Object.values(this.product.FILTERS?.QUANTITY_PACK || {})
                .filter((item) => Object.values(this.product.OFFERS)
                    .find((offer) => {
                        const normalQuantityValue = offer?.PROPERTIES?.SHTUK_V_UPAKOVKE?.VALUE.replace(/\s/g, '');

                        return normalQuantityValue === `${item.VALUE}`;
                    }));
        },

        currentOffer() {
            // количество штук в упаковке
            if (this.product.FILTERS?.QUANTITY_PACK) {
                return Object.values(this.product.OFFERS)
                    .find((offer) => {
                        const quantityValue = offer?.PROPERTIES?.SHTUK_V_UPAKOVKE?.VALUE.replace(/\s/g, '');

                        return quantityValue === this.selectedQuantity;
                    });
            }

            return Object.values(this.product.OFFERS)
                .find((offer) => {
                    const weightValue = offer?.PROPERTIES?.VES_UPAKOVKI?.VALUE.replace(/\s/g, '');
                    const roastValue = offer?.PROPERTIES?.STEPEN_OBZHARKI?.VALUE;

                    return weightValue === this.selectedWeight
                        && roastValue === this.selectedRoastValue;
                });
        },

        prices() {
            const price = this.currentOffer?.CURRENT_PRICE || this.product?.CURRENT_PRICE;
            return {
                current: price?.PRINT_DISCOUNT_VALUE,
                old: price?.PRINT_VALUE !== price?.PRINT_DISCOUNT_VALUE ? price?.PRINT_VALUE : null,
            };
        },

        basketRows() {
            return Object.values(this.$basketService.state.basketData?.BASKET?.ITEMS || {});
        },

        productInCart() {
            return this.basketRows.find((basketItem) => `${basketItem.PRODUCT_ID}` === `${this.currentOffer?.ID}`);
        },

        showDetailHint() {
            if (!Cookies.get('BX_ONBOARDING_DETAIL_CLOSE')) {
                return true;
            }

            return false;
        },
    },

    watch: {
        weightItems: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                let initOffer = null;

                if (!this.isWeightValueInit) {
                    this.isWeightValueInit = true;
                    initOffer = this.getInitOffer(newValue);
                }

                // закомментированно переключение веса после выбора обжарки
                // this.selectedWeight = initOffer ? initOffer.VALUE : newValue[0].VALUE;
                this.selectedWeight = initOffer ? initOffer.VALUE : this.selectedWeight;
            },
        },

        roast: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length || this.isRoastValueInit) {
                    return;
                }

                let initOffer = null;

                if (!this.isRoastValueInit) {
                    this.isRoastValueInit = true;
                    initOffer = this.getInitOffer(newValue);
                }

                this.selectedRoastValue = initOffer ? initOffer.VALUE : newValue[0].VALUE;
            },
        },

        selectedRoastValue: {
            immediate: true,
            handler(newValue) {
                this.selectBrewingTypes(newValue);
            },
        },

        quantity: 'quantityWatchHandler',

        quantityItems: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                this.selectedQuantity = newValue[0].VALUE;
            },
        },

        grinding: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    return;
                }

                this.selectedGrindingId = newValue[0].ID;
            },
        },

        productInCart: {
            immediate: true,
            deep: true,
            handler(newProduct) {
                this.productChangeProcess = true;

                if (newProduct) {
                    this.quantity = newProduct.QUANTITY;
                } else {
                    this.quantity = 1;
                }

                this.$nextTick(() => {
                    this.productChangeProcess = false;
                });
            },
        },

        currentOffer: {
            immediate: true,
            handler(newOffer) {
                if (newOffer) {
                    console.log(this.currentOffer);
                    const image = this.currentOffer?.DETAIL_PICTURE?.SRC || window.specialtyApp?.settings?.EMPTY_IMG_COFFEE_BOX_SRC;
                    const zoom = this.currentOffer?.DETAIL_PICTURE?.ZOOM || window.specialtyApp?.settings?.EMPTY_IMG_COFFEE_BOX_SRC;

                    eventBus.$emit(EVENT_DETAIL_OFFER_PAGE, {
                        data: { image, zoom},
                    });

                    const url = new URL(window.location.href);
                    url.searchParams.delete('offer')

                    if (newOffer.ID && (this.getMinWeightOffer()?.ID !== newOffer.ID)) {
                        url.searchParams.set('offer', newOffer.ID);
                    }

                    window.history.replaceState({}, null, url);

                }
            },
        },
    },

    mounted() {
        const selectedBreWValue = Cookies.get('SELECTED_BREW');

        if (this.selectedRoastValue) {
            this.clickOnBrew = false;
            this.selectBrewingTypes(this.selectedRoastValue);
        }

        if (selectedBreWValue && this.roast.length > 1) {
            this.brewingTypes.forEach((val) => {
                if (selectedBreWValue === val.ID) {
                    // console.log(val.DEFAULT);
                    const btn = document.querySelector(`.product-page-cart__brewing-item[data-id="${val.ID}"]`);
                    this.selectBrewingType(val.DEFAULT, btn);
                    return false;
                }

                return false;
            });
        }
    },
};
</script>
